"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _IconSVG = _interopRequireDefault(require("../components/IconSVG"));
var _excluded = ["size", "title", "ariaHidden"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var pathSizesToPaths = {
  "16": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M.005 8C.005 3.591 3.592.004 8 .004c4.408 0 7.994 3.587 7.994 7.996 0 4.408-3.586 7.995-7.994 7.995a7.937 7.937 0 0 1-5.651-2.344 7.942 7.942 0 0 1-2.345-5.65Zm14.99 0c0-3.858-3.137-6.996-6.994-6.996A7.004 7.004 0 0 0 1.005 8c0 3.857 3.139 6.995 6.996 6.995 3.857 0 6.994-3.138 6.994-6.995Zm-11.591.801 3.082 3.04 6.125-6.168-.71-.706-5.423 5.461L4.107 8.09l-.703.712Z"
  }),
  "24": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M.075 12C.075 5.424 5.425.074 12.001.074c3.18 0 6.174 1.242 8.428 3.497A11.844 11.844 0 0 1 23.925 12c0 6.576-5.349 11.925-11.924 11.925-3.18 0-6.174-1.242-8.43-3.496a11.842 11.842 0 0 1-3.496-8.43ZM22.8 12c0-5.956-4.843-10.801-10.8-10.801-5.954 0-10.8 4.845-10.8 10.8C1.2 17.957 6.045 22.8 12 22.8c5.956 0 10.8-4.845 10.8-10.8ZM5.05 13.088l4.61 4.545 9.31-9.374-.798-.793-8.52 8.58-3.81-3.759-.791.801Z"
  }),
  "32": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M.1 16C.1 7.232 7.233.099 16.001.099A15.79 15.79 0 0 1 27.24 4.762 15.792 15.792 0 0 1 31.9 16c0 8.768-7.132 15.9-15.899 15.9a15.797 15.797 0 0 1-11.239-4.66A15.789 15.789 0 0 1 .1 15.999Zm30.3 0c0-7.941-6.458-14.401-14.399-14.401-7.94 0-14.4 6.46-14.4 14.4 0 7.942 6.46 14.402 14.4 14.402s14.4-6.46 14.4-14.401ZM6.734 17.45l6.146 6.06 12.414-12.498-1.065-1.057-11.36 11.439-5.08-5.011-1.055 1.068Z"
  }),
  "48": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M.058 23.998C.058 10.79 10.804.043 24.013.043c6.389 0 12.4 2.495 16.93 7.024 4.527 4.53 7.022 10.542 7.02 16.931 0 13.21-10.744 23.955-23.95 23.955-6.39 0-12.403-2.494-16.932-7.024C2.552 36.4.058 30.387.058 24Zm46.03 0c.002-12.175-9.9-22.08-22.075-22.08-12.175 0-22.08 9.905-22.08 22.08 0 12.175 9.905 22.08 22.08 22.08 12.174 0 22.076-9.905 22.076-22.08ZM9.957 26.071l9.27 9.143L38.11 16.2l-1.33-1.32-17.568 17.687-7.94-7.831-1.316 1.335Z"
  }),
  "64": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M.077 31.998c0-17.612 14.328-31.94 31.94-31.94 8.519 0 16.535 3.326 22.573 9.365 6.037 6.039 9.363 14.056 9.362 22.575 0 17.612-14.326 31.94-31.935 31.94-8.52 0-16.537-3.326-22.575-9.365C3.402 48.533.077 40.516.077 31.998Zm61.375 0c0-16.233-13.202-29.44-29.435-29.44-16.233 0-29.44 13.207-29.44 29.44s13.207 29.44 29.44 29.44c16.232 0 29.435-13.207 29.435-29.44ZM13.274 34.76l12.361 12.191L50.813 21.6l-1.774-1.76-23.423 23.583L15.03 32.981l-1.756 1.78Z"
  })
};
var pathSizesToViewBox = {
  "16": "0 0 16 16",
  "24": "0 0 24 24",
  "32": "0 0 32 32",
  "48": "0 0 48 48",
  "64": "0 0 64 64"
};
var sizesToPathSizes = {
  "16": "16",
  "24": "24",
  "32": "32",
  "48": "48",
  "64": "64"
};
var sizes = ['16', '24', '32', '48', '64'];
var IconSuccessAlert = function IconSuccessAlert(_ref) {
  var _ref$size = _ref.size,
    sizeProp = _ref$size === void 0 ? '32' : _ref$size,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'Success Alert' : _ref$title,
    _ref$ariaHidden = _ref.ariaHidden,
    ariaHidden = _ref$ariaHidden === void 0 ? false : _ref$ariaHidden,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var size = sizes.indexOf(sizeProp) !== -1 ? sizeProp : '32';
  return /*#__PURE__*/_react.default.createElement(_IconSVG.default, (0, _extends2.default)({
    width: size,
    height: size,
    viewBox: pathSizesToViewBox[sizesToPathSizes[size]],
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    role: "img",
    title: title,
    ariaHidden: ariaHidden
  }, props, {
    iconClass: "SuccessAlert"
  }), pathSizesToPaths[sizesToPathSizes[size]]);
};
IconSuccessAlert.sizes = [16, 24, 32, 48, 64];
IconSuccessAlert.propTypes = {
  /** Available sizes: 16, 24, 32, 48, 64. In most cases, the size will be a square (e.g., 32px X 32px), but height variances can occur. */
  size: _propTypes.default.oneOf(sizes),
  /** Similar to the 'alt' attribute on image tags, this is optional for custom tooltips and will default to the icon name if not overriden. */
  title: _propTypes.default.string,
  /** Hide icon from screen readers. */
  ariaHidden: _propTypes.default.bool,
  /** Optional custom class. */
  className: _propTypes.default.string
};
var _default = IconSuccessAlert;
exports.default = _default;